export default __webpack_public_path__ + "static/media/candy.a6b8a53c.png";